var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.84,302.24s-70.73-33.92-114.6-33.92c-52.67,0-103.85,15.12-123.27,20.11-51,13.11-149.81,13.81-149.81,13.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.16,302.24s40.16-19.73,85.53-19.73c31.67,0,77.13,4.09,119.94,10.78,16.3,2.55,101.15,8.95,101.15,8.95Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.42,232.83c-4.77,0-123.93-.83-157.58-.83-2.36,0,.62-4.08,1.92-4.36,4.13-.91,8.45-1,12.65-1.39a41.48,41.48,0,0,0,12.06-3c3.31-1.4,6.62-3,10.2-3.58,6.94-1.08,13,2.67,19.52,4.33A14.73,14.73,0,0,0,339,222.37c3-1.81,5.74-4,8.89-5.56A48.73,48.73,0,0,1,386.83,215a45.94,45.94,0,0,1,8.52,4.36c3.18,2.09,5.92,4.75,9.1,6.81,7.06,4.57,15.79,3.08,23.48,5.7C428.36,232,428.83,232.83,428.42,232.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,82.49c-6.31,0-112.54.7-119.22.49-.48,0-.74-.72-.26-1,4.21-2.08,9-1.66,13.36-3.13,2.57-.87,4.15-2.55,5.94-4.48A12.3,12.3,0,0,1,306,70.8a11.61,11.61,0,0,1,6-.19c2.16.51,4,1.75,6.08,2.52,5.11,1.93,10.07.1,13.71-3.68,3-3.11,6-6.05,10.05-7.72a13.31,13.31,0,0,1,10.64-.15C356.36,63.35,359,66.9,362.7,69,367,71.57,372.23,71,377,71.73s8.47,4.8,12.67,7.13a9.06,9.06,0,0,0,4.58,1.42c.94,0,1.86-.28,2.79-.4,1.45-.18,2.82-.13,3.8,1.07C401.09,81.25,401,82.49,400.63,82.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.42,121.27c-4.61,0-82.17.51-87,.36-.35,0-.54-.53-.19-.7,3.07-1.52,6.56-1.22,9.75-2.29a10.44,10.44,0,0,0,4.33-3.27,9,9,0,0,1,4-2.64,8.6,8.6,0,0,1,4.39-.14,38.3,38.3,0,0,1,4.45,1.85c3.72,1.4,7.34.07,10-2.69,2.2-2.27,4.35-4.42,7.34-5.64a9.72,9.72,0,0,1,7.77-.11c2.84,1.29,4.79,3.88,7.46,5.44,3.17,1.85,7,1.42,10.46,2s6.18,3.51,9.25,5.21a6.56,6.56,0,0,0,3.35,1,17.4,17.4,0,0,0,2-.29,2.77,2.77,0,0,1,2.77.79C462.76,120.36,462.72,121.27,462.42,121.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.05,153.18c-4.61,0-82.16.51-87,.35-.35,0-.54-.52-.19-.69,3.07-1.53,6.56-1.22,9.75-2.3a10.31,10.31,0,0,0,4.34-3.27,9,9,0,0,1,4-2.63,8.49,8.49,0,0,1,4.39-.14,39.91,39.91,0,0,1,4.44,1.84c3.73,1.41,7.35.07,10-2.68,2.19-2.28,4.35-4.42,7.33-5.64a9.72,9.72,0,0,1,7.77-.11c2.85,1.29,4.8,3.88,7.47,5.44,3.17,1.85,7,1.41,10.45,2s6.19,3.51,9.26,5.2a6.56,6.56,0,0,0,3.34,1,20,20,0,0,0,2-.29,2.79,2.79,0,0,1,2.77.78C215.39,152.27,215.36,153.18,215.05,153.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73,105.71c-4.61,0-82.17.51-87,.35-.35,0-.54-.52-.19-.69,3.07-1.52,6.56-1.22,9.75-2.3a10.28,10.28,0,0,0,4.33-3.27,9.08,9.08,0,0,1,4-2.63A8.49,8.49,0,0,1,60,97a38.3,38.3,0,0,1,4.45,1.85c3.72,1.4,7.34.07,10-2.69,2.2-2.27,4.35-4.42,7.34-5.64a9.72,9.72,0,0,1,7.77-.11c2.84,1.29,4.79,3.88,7.46,5.44,3.17,1.85,7,1.41,10.46,2s6.18,3.51,9.25,5.2a6.57,6.57,0,0,0,3.35,1,19.84,19.84,0,0,0,2-.29,2.79,2.79,0,0,1,2.77.78C125.07,104.8,125,105.71,124.73,105.71Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.17,318.71a139.24,139.24,0,0,1,23.9,0,138.23,138.23,0,0,1-23.9,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.07,386c-39.47.66-83.36.64-122.86,0,39.51-.65,83.38-.67,122.86,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.81,349.42c-38.8.66-81.93.65-120.76,0,38.84-.65,82-.66,120.76,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,386c-21.17.67-42.47.67-63.63,0,21.16-.68,42.46-.68,63.63,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,406.92c-42.6.67-90,.65-132.59,0,42.64-.65,90-.66,132.59,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,394c-21.16.67-42.46.67-63.63,0,21.17-.68,42.47-.68,63.63,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.93,373.42c-21.16.67-42.46.67-63.63,0,21.17-.67,42.47-.67,63.63,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,442.78c-21.16.67-42.46.67-63.63,0,21.17-.67,42.47-.67,63.63,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.32,430.7c-38.9.67-82.15.65-121.08,0,38.94-.64,82.17-.66,121.08,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,321.27c-21.16.67-42.47.67-63.63,0,21.16-.67,42.46-.67,63.63,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,324c-21.16.67-42.47.67-63.63,0,21.16-.67,42.46-.67,63.63,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89,310.17c-35,.67-74,.65-109.1,0,35.08-.64,74-.66,109.1,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,370.71a198.5,198.5,0,0,1-28.44,0,198.5,198.5,0,0,1,28.44,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.61,415.13c-36,.66-76,.65-112,0,36-.65,76-.67,112,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,365c-47.5.66-100.3.65-147.83,0,47.54-.65,100.32-.66,147.83,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.36,436.72a198.64,198.64,0,0,1-28.45,0,198.64,198.64,0,0,1,28.45,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.75,302.24c130.86-.61,277.64-.62,408.5,0-130.86.62-277.64.61-408.5,0Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.49,39.65a8.32,8.32,0,0,1,0,11.44,7.43,7.43,0,0,1-5.41,2.42,7.59,7.59,0,0,1-5.53-2.42,8.42,8.42,0,0,1,0-11.44,7.52,7.52,0,0,1,5.53-2.42A7.35,7.35,0,0,1,228.49,39.65Zm-.3,5.72a5.85,5.85,0,0,0-1.53-3.95,4.87,4.87,0,0,0-7.24,0,5.82,5.82,0,0,0,0,7.89,4.85,4.85,0,0,0,7.24,0A5.81,5.81,0,0,0,228.19,45.37Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,39.65a8.32,8.32,0,0,1,0,11.44,7.41,7.41,0,0,1-5.4,2.42,7.62,7.62,0,0,1-5.54-2.42,8.42,8.42,0,0,1,0-11.44,7.54,7.54,0,0,1,5.54-2.42A7.33,7.33,0,0,1,247.48,39.65Zm-.3,5.72a5.85,5.85,0,0,0-1.53-3.95,4.88,4.88,0,0,0-3.57-1.61,4.93,4.93,0,0,0-3.67,1.61,5.85,5.85,0,0,0,0,7.89,5,5,0,0,0,3.67,1.62,4.92,4.92,0,0,0,3.57-1.62A5.81,5.81,0,0,0,247.18,45.37Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.51,47.36h-2.78v4.91a1.26,1.26,0,0,1-1.27,1.24,1.25,1.25,0,0,1-1.24-1.24V38.93a1.23,1.23,0,0,1,1.24-1.24h4a4.84,4.84,0,1,1,0,9.67Zm-2.78-2.51h2.78a2.33,2.33,0,1,0,0-4.65h-2.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9,49.58a1.17,1.17,0,0,1,1.65-.16,7.42,7.42,0,0,0,4.32,1.74,4.82,4.82,0,0,0,2.82-.84,2,2,0,0,0,1-1.62,1.28,1.28,0,0,0-.21-.73,2.17,2.17,0,0,0-.68-.68,9,9,0,0,0-3.09-1.06h-.05a11.8,11.8,0,0,1-2.91-.88,4.91,4.91,0,0,1-2.11-1.76,3.5,3.5,0,0,1-.52-1.86,4.19,4.19,0,0,1,1.81-3.3,6.67,6.67,0,0,1,3.91-1.2A8.9,8.9,0,0,1,277.75,39a1.17,1.17,0,0,1,.32,1.61,1.15,1.15,0,0,1-1.61.34,6.54,6.54,0,0,0-3.64-1.45,4.34,4.34,0,0,0-2.53.77,1.8,1.8,0,0,0-.86,1.42,1.17,1.17,0,0,0,.16.64,2.14,2.14,0,0,0,.61.58A7.84,7.84,0,0,0,273,44h0a13,13,0,0,1,3.12.95,5.28,5.28,0,0,1,2.26,1.87A3.68,3.68,0,0,1,279,48.7a4.37,4.37,0,0,1-1.94,3.5,7.11,7.11,0,0,1-4.18,1.29,9.79,9.79,0,0,1-5.79-2.26A1.21,1.21,0,0,1,266.9,49.58Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.23,48.06V38.93a1.25,1.25,0,0,1,1.24-1.24,1.23,1.23,0,0,1,1.22,1.24v9.13a1.23,1.23,0,0,1-1.22,1.25A1.24,1.24,0,0,1,282.23,48.06Zm1.24,5.45a1.23,1.23,0,0,1-1.24-1.24v-.46a1.25,1.25,0,0,1,1.24-1.24,1.24,1.24,0,0,1,1.22,1.24v.46A1.22,1.22,0,0,1,283.47,53.51Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-2--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.25,186a11.89,11.89,0,0,1-12.09,11.88H430V214.3a11.88,11.88,0,0,1-23.75,0V197.89h-68a10.6,10.6,0,0,1-7.34-2.59A11.56,11.56,0,0,1,329,178.67l79.88-99.31c.22,0,.22-.22.43-.43a2.8,2.8,0,0,0,.65-.87,2.27,2.27,0,0,0,1.08-.64c.22-.22.65-.44.87-.65a2.25,2.25,0,0,1,1.29-.43c.21-.44.43-.65.86-.65.22-.22.65-.22,1.3-.43a1.27,1.27,0,0,0,.86-.22h3.67a1.92,1.92,0,0,0,1.08.22c.22.21.87.21,1.3.43.21,0,.65.21.86.21.44.44.86.65,1.08.87.43.21.65.43,1.08.65a.21.21,0,0,1,.22.21c.21,0,.64.22.64.43l.87.87c.21.21.43.64.65.86a6.22,6.22,0,0,1,.86,1.08,1.63,1.63,0,0,0,.43.86,8.8,8.8,0,0,1,.44,1.3c0,.21.21.65.21.86a2.4,2.4,0,0,1,.21,1.3c0,.43.22.65.22,1.08v87.87h2.16A12,12,0,0,1,444.25,186Zm-38-65.2-43,53.33h43Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-1--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.7,186a11.89,11.89,0,0,1-12.09,11.88h-2.16V214.3a11.88,11.88,0,0,1-23.75,0V197.89h-68a10.6,10.6,0,0,1-7.34-2.59,11.56,11.56,0,0,1-1.94-16.63l79.88-99.31c.22,0,.22-.22.43-.43a3,3,0,0,0,.65-.87,2.32,2.32,0,0,0,1.08-.64c.21-.22.65-.44.86-.65a2.31,2.31,0,0,1,1.3-.43c.21-.44.43-.65.86-.65.22-.22.65-.22,1.3-.43a1.28,1.28,0,0,0,.86-.22h3.67a1.92,1.92,0,0,0,1.08.22c.22.21.86.21,1.3.43.21,0,.64.21.86.21.43.44.86.65,1.08.87.43.21.65.43,1.08.65a.21.21,0,0,1,.21.21c.22,0,.65.22.65.43l.87.87c.21.21.43.64.64.86a5.67,5.67,0,0,1,.87,1.08,1.56,1.56,0,0,0,.43.86,7.87,7.87,0,0,1,.43,1.3c0,.21.22.65.22.86a2.4,2.4,0,0,1,.21,1.3c0,.43.22.65.22,1.08v87.87h2.16A12,12,0,0,1,173.7,186Zm-38-65.2-43,53.33h43Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lighthouse--inject-115"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.05,150.61c0,23-6.07,44.3-16.95,60.5-10.65,16-27.35,28.12-46.85,28.12-20,0-36.45-12.15-47.1-28.12-11.13-16.2-17-37.46-17.2-60.5.25-23.3,6.07-44.31,17.2-60.52,10.65-16.2,27.1-28.1,47.1-28.1,19.5,0,36.2,11.9,46.85,28.1C308,106.3,314.05,127.31,314.05,150.61Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.91,150.61c0,19.75-5.21,38-14.54,51.86-9.12,13.69-23.44,24.1-40.15,24.1-17.15,0-31.25-10.41-40.38-24.1-9.54-13.89-14.53-32.11-14.75-51.86.22-20,5.21-38,14.75-51.88,9.13-13.89,23.23-24.09,40.38-24.09,16.71,0,31,10.2,40.15,24.09C299.7,112.63,304.91,130.64,304.91,150.61Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.06,150.61c0,14.41-3.8,27.7-10.61,37.84-6.65,10-17.1,17.58-29.29,17.58-12.51,0-22.8-7.6-29.46-17.58-7-10.14-10.6-23.43-10.76-37.84.16-14.57,3.8-27.71,10.76-37.85,6.66-10.13,17-17.58,29.46-17.58,12.19,0,22.64,7.45,29.29,17.58C286.26,122.9,290.06,136,290.06,150.61Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "291.81 347.63 208.19 347.63 210.53 314.11 212.88 280.59 215.22 247.06 217.57 213.54 219.91 180.01 280.09 180.01 282.43 213.54 284.78 247.06 287.12 280.59 289.47 314.11 291.81 347.63",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.43 213.54 217.57 213.54 219.91 180.01 280.09 180.01 282.43 213.54",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.81 347.63 208.19 347.63 210.53 314.11 289.47 314.11 291.81 347.63",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.12 280.59 212.88 280.59 215.22 247.06 284.78 247.06 287.12 280.59",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.91 180.01 235.03 180.01 255.56 347.63 208.19 347.63 219.91 180.01",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,193.81h0a4.05,4.05,0,0,0-4.05,4.05l-.85,8.79h9.8l-.85-8.79A4.05,4.05,0,0,0,250,193.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.36,225.24h0a4,4,0,0,0-4.05,4l-.86,8.79h9.81l-.85-8.79A4.05,4.05,0,0,0,266.36,225.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,258.48h0a4.05,4.05,0,0,0-4.05,4l-.85,8.79h9.8l-.85-8.79A4.06,4.06,0,0,0,225.56,258.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,291.86h0a4,4,0,0,0-4.05,4l-.85,8.8h9.8l-.85-8.8A4,4,0,0,0,250,291.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.22,131.67H231.78a18.23,18.23,0,0,1,36.4-1.33C268.21,130.78,268.22,131.23,268.22,131.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.23,131.67H231.78a18,18,0,0,1,.34-3.54l35.24-2a18.32,18.32,0,0,1,.82,4.23C268.21,130.78,268.23,131.22,268.23,131.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.4,
    y: 140.98,
    width: 23.32,
    height: 2.56,
    transform: "translate(375.32 -90.8) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.18,
    y: 140.98,
    width: 23.32,
    height: 2.56,
    transform: "translate(382.09 -97.58) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.95,
    y: 140.98,
    width: 23.32,
    height: 2.56,
    transform: "translate(388.87 -104.35) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.73,
    y: 140.98,
    width: 23.32,
    height: 2.56,
    transform: "translate(395.65 -111.13) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.51,
    y: 140.98,
    width: 23.32,
    height: 2.56,
    transform: "translate(402.42 -117.91) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.62,
    y: 143.38,
    width: 40.76,
    height: 1.98,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.28,
    y: 140.98,
    width: 23.32,
    height: 2.56,
    transform: "translate(409.2 -124.68) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.08,
    y: 153.92,
    width: 43.84,
    height: 21.08,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.92 153.92 271.92 157.88 228.08 165 228.08 153.92 271.92 153.92",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 270.75,
    y: 289.73,
    width: 9.8,
    height: 4.14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 265.28,
    y: 294.95,
    width: 9.8,
    height: 4.14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 234.59,
    y: 228.51,
    width: 9.8,
    height: 4.14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 229.12,
    y: 233.73,
    width: 9.8,
    height: 4.14
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 223.67,
    y: 228.51,
    width: 9.8,
    height: 4.14
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 247.04,
    y: 120.98,
    width: 7.5,
    height: 3.17
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 242.85,
    y: 124.98,
    width: 7.5,
    height: 3.17
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 238.69,
    y: 120.98,
    width: 7.5,
    height: 3.17
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 218.28,
    y: 293.3,
    width: 9.8,
    height: 4.14
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 259.31,
    y: 193.81,
    width: 9.8,
    height: 4.14
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 264.77,
    y: 199.04,
    width: 9.8,
    height: 4.14
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 159.78,
    width: 9.8,
    height: 4.14
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 255.47,
    y: 165,
    width: 9.8,
    height: 4.14
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 256.64,
    width: 9.8,
    height: 4.14
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 172.87,
    width: 73.4,
    height: 14.29,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 150.61,
    width: 49.03,
    height: 5.16,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.62,
    y: 130.6,
    width: 40.76,
    height: 4.29,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.29,313.74c-1.58.05-3.33.14-4.64-.88a4.71,4.71,0,0,1-2.11-4c0-.46.15-.74.64-.54a5.88,5.88,0,0,1,1.85,1.7,15.23,15.23,0,0,0,2.18,2.07c.56.43,1.17.8,1.74,1.22l.21.16.08.06h.05a.07.07,0,0,1,.06,0s0,0,0,0A.09.09,0,0,1,275.29,313.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.36,313.63c-1.38,0-2.87,0-4-.9a6.2,6.2,0,0,1-1.28-1.56c-.16-.26-.64-1-.44-1.34.36-.56,2,1.72,2.23,1.93a6.78,6.78,0,0,0,3.06,1.59l.21.16a7.5,7.5,0,0,1-2.29-.88,11.2,11.2,0,0,1-2.3-2.26c-.17-.18-.67-.76-.85-.4s.33,1,.43,1.17a6.42,6.42,0,0,0,1.22,1.48c1.1,1,2.59.93,4,1C275.36,313.61,275.36,313.62,275.36,313.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.15,314.7l0,.18h0a.05.05,0,0,1,0,0,.09.09,0,0,1-.09,0v-.06l0-.05h0c-.28-1.05-.39-2.13-.68-3.17s-.63-2-.83-3c-.13-.64-.57-3.85.84-3.45.63.17,1.06,1.08,1.29,1.62a6.82,6.82,0,0,1,.53,2.31C277.27,311,276.55,312.82,276.15,314.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.61,310.7a8,8,0,0,0-.23-2.18c-.06-.25-.37-1.43-.77-1.4s-.3.53-.33.7a6.82,6.82,0,0,0,.29,2.14,29.4,29.4,0,0,1,.51,4.28l0,.28,0,.23s0,.05,0,.07v.06a.07.07,0,0,0,.08,0l0-.18v.14h0l0-.15v-.27A31.89,31.89,0,0,0,276.61,310.7Zm-.48,3.24c0-.84-.12-1.68-.24-2.51s-.22-1.34-.37-2a7.19,7.19,0,0,1-.18-1.13c0-.3,0-1.38.59-.71a4.46,4.46,0,0,1,.55,2.12,10.29,10.29,0,0,1,0,2C276.37,312.45,276.24,313.19,276.13,313.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,319h-.06c-1.44-.07-3.35.06-4.55-.89a3.65,3.65,0,0,1-1.47-3.27c.31-1.33,2.11.27,2.58.65a43.41,43.41,0,0,1,3.53,3.43l0,0h0S277,319,277,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,319l-.25-.15c-.94-.6-1.87-1.24-2.75-1.92-.23-.17-1.85-1.61-2.09-1.09-.15.31.39.94.56,1.16a4.57,4.57,0,0,0,1.09,1,11.36,11.36,0,0,0,3.21,1l.15,0h0S277.06,319,277.05,319Zm-2.85-.82a4.45,4.45,0,0,1-1.24-.84c-.24-.23-1.09-1.09-.86-1.44.12-.19.22-.09.45,0l.3.18c.24.16.46.34.69.52.39.32.79.62,1.2.92.67.49,1.36.95,2.06,1.38A21.39,21.39,0,0,1,274.2,318.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,316.05a8.5,8.5,0,0,1-2.47,4.31h0a.08.08,0,0,1-.08,0s0-.06,0-.09l.07-.07c.24-2,.5-3.9.71-5.86,0-.47.4-3.41,1.31-2.93.56.3.59,1.5.64,2A8.47,8.47,0,0,1,279.63,316.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11,313.43c-.05-.17-.14-.33-.32-.22-.35.22-.49,1.6-.55,2-.24,1.57-.61,3.09-1,4.64,0,.13-.07.26-.1.39l-.09.12a.08.08,0,0,0,.08,0,.08.08,0,0,1,0,0l.12-.16h0a10,10,0,0,0,1.42-2.77,9.2,9.2,0,0,0,.42-1.94A5.54,5.54,0,0,0,279.11,313.43Zm-1.85,6.64a.22.22,0,0,0-.05.08.75.75,0,0,1,.05-.16,29.83,29.83,0,0,0,.88-3.59c.1-.62.17-1.24.29-1.86.06-.25.18-1,.4-1.11s.21.17.23.33a3.46,3.46,0,0,1,0,.45A10,10,0,0,1,277.26,320.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,324.58h-.29c0-.26,0-.51,0-.76,0-1-.08-2.05-.14-3.07,0-.58-.07-1.16-.14-1.73V319s0-.1,0-.14a.77.77,0,0,0,0-.15,12.17,12.17,0,0,0-1-3.76c-.18-.4-.38-.79-.59-1.17l-.06-.11,0,0-.06-.12-.05-.08c-.66-1.17-1.43-2.29-2.15-3.42l-.61-1,0-.06,0-.07c-.9-1.43-1.8-2.88-2.74-4.28,0-.05.05-.1.08-.05.64.94,1.3,1.85,1.95,2.77l.26.37.52.73,1,1.47a43.74,43.74,0,0,1,2.65,4.29l.16.34.1.21c0,.08.07.16.11.25a13.37,13.37,0,0,1,1,4.53c0,.11,0,.22,0,.33a.81.81,0,0,0,0,.15v.08a.34.34,0,0,0,0,.1h0v.08c0,.1,0,.19,0,.28,0,1,.07,2.05.09,3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.81,306.06c-.78-1.06-1.79-3.24-.63-4.38a1.23,1.23,0,0,1,1.64-.12,3.55,3.55,0,0,1,1.09,2c.53,1.86.88,3.75,1.55,5.56a1.5,1.5,0,0,1,.07.2s0,0-.06,0l-.06-.17A15.83,15.83,0,0,1,268.81,306.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.47,309.1s0,0,0,0a12.07,12.07,0,0,1-.74-1.37,26.86,26.86,0,0,1-1.13-3c-.12-.4-.69-2.35-1.39-1.57a1.75,1.75,0,0,0-.2,1.31,5,5,0,0,0,.6,1.82,9,9,0,0,0,2.62,2.73l.14.11,0,.05,0,0h0s.06,0,.06,0S272.48,309.11,272.47,309.1Zm-.31-.22a10.57,10.57,0,0,1-2.21-2.22,5.37,5.37,0,0,1-.73-1.48,4.27,4.27,0,0,1-.15-.71,2.54,2.54,0,0,1,0-.55c0-.4.17-.83.41-.88s.39.12.58.46a2.31,2.31,0,0,1,.18.35,7.71,7.71,0,0,1,.32.92c.17.52.33,1,.52,1.54.12.34.26.68.4,1a13.36,13.36,0,0,0,.87,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,318c-1.36.34-2.88.73-4.2.07a4.2,4.2,0,0,1-2.55-3.07c0-.41,0-.67.46-.59a5.08,5.08,0,0,1,1.92,1.16,14.33,14.33,0,0,0,2.27,1.41c.57.27,1.16.49,1.73.75l.22.1.08,0h0s0,0,.06,0l0,0A.07.07,0,0,1,188,318Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,317.88c-1.21.23-2.5.55-3.64-.07a6.09,6.09,0,0,1-1.4-1.13c-.18-.2-.74-.79-.62-1.09.21-.56,2.06,1.13,2.3,1.28a6,6,0,0,0,2.94.84l.22.1a6.89,6.89,0,0,1-2.16-.36,10,10,0,0,1-2.41-1.56c-.17-.12-.71-.54-.81-.19s.47.81.59.94a5.68,5.68,0,0,0,1.32,1.07c1.14.64,2.43.35,3.65.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,318.67v.16h0s0,0,0,0a.06.06,0,0,1-.08,0s0,0,0,0v-.07h0v0c-.43-.85-.72-1.78-1.16-2.63s-.9-1.61-1.26-2.46c-.23-.53-1.19-3.25.11-3.16.58,0,1.12.76,1.42,1.19a6,6,0,0,1,.87,1.92A19.2,19.2,0,0,1,188.92,318.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,315.1a7.2,7.2,0,0,0-.59-1.86c-.1-.2-.58-1.18-.93-1.08s-.16.51-.15.66a6.22,6.22,0,0,0,.62,1.82,26,26,0,0,1,1.23,3.64,2,2,0,0,0,0,.25c0,.07,0,.13,0,.2v.13a.06.06,0,0,0,.08,0,.86.86,0,0,1,0-.16.79.79,0,0,0,0,.13h0v-.16c0-.07,0-.14,0-.21A31.48,31.48,0,0,0,188.6,315.1Zm.16,2.91c-.19-.73-.41-1.44-.66-2.15s-.44-1.13-.68-1.68a6.12,6.12,0,0,1-.36-1c-.06-.25-.22-1.2.39-.72a3.94,3.94,0,0,1,.86,1.75,10.37,10.37,0,0,1,.32,1.75C188.7,316.67,188.72,317.34,188.76,318Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.43,322.28h0l-.05,0c-1.27.19-2.92.65-4.13,0a3.25,3.25,0,0,1-1.87-2.59c0-1.22,1.89-.15,2.37.1a39.89,39.89,0,0,1,3.69,2.36l0,0h0S190.46,322.27,190.43,322.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,322.23l-.24-.09c-.93-.35-1.85-.74-2.74-1.17-.23-.11-1.9-1.08-2-.58-.07.29.51.75.69.91a3.87,3.87,0,0,0,1.13.65,9.88,9.88,0,0,0,3,.31h.17S190.48,322.25,190.46,322.23Zm-2.62-.2a4,4,0,0,1-1.24-.51c-.25-.16-1.14-.76-1-1.1s.18-.12.4-.06a1.42,1.42,0,0,1,.29.1,6.36,6.36,0,0,1,.7.33c.4.2.8.4,1.21.58.67.31,1.35.58,2,.84A21,21,0,0,1,187.84,322Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,319.22a7.63,7.63,0,0,1-1.38,4.2l0,0a.06.06,0,0,1-.07,0,.06.06,0,0,1,0-.08l0-.07c-.14-1.75-.26-3.49-.44-5.24,0-.41-.25-3,.63-2.79.54.16.78,1.21.92,1.67A7.52,7.52,0,0,1,192.19,319.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.26,317c-.07-.13-.17-.26-.31-.13s-.14,1.48-.12,1.83c.07,1.42,0,2.81,0,4.22,0,.12,0,.24,0,.36l-.06.12a.06.06,0,0,0,.07,0v0a.8.8,0,0,0,.08-.16h0a8.92,8.92,0,0,0,.74-2.67,8.73,8.73,0,0,0,0-1.77A4.83,4.83,0,0,0,191.26,317Zm-.42,6.12,0,.08c0-.05,0-.1,0-.15a25.78,25.78,0,0,0,.12-3.29c0-.55-.07-1.11-.07-1.66,0-.24,0-.91.14-1.05s.21.11.26.25a2.79,2.79,0,0,1,.1.39A8.78,8.78,0,0,1,190.84,323.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.78,327.05l-.26.06-.15-.66c-.21-.89-.43-1.77-.67-2.65-.13-.5-.27-1-.43-1.49a.43.43,0,0,1,0-.05s0-.08,0-.12,0-.08,0-.13a10.9,10.9,0,0,0-1.54-3.09c-.23-.32-.47-.62-.73-.92a.27.27,0,0,0-.07-.08l0,0-.07-.09-.06-.06c-.79-.9-1.66-1.74-2.49-2.59l-.71-.74,0-.05-.06-.05c-1-1.08-2.08-2.18-3.15-3.24,0,0,0-.09.06-.05.72.69,1.46,1.38,2.2,2.06l.29.28.58.54c.39.36.77.73,1.14,1.1a37.93,37.93,0,0,1,3.08,3.26l.2.27a1.09,1.09,0,0,1,.13.17l.14.19a11.67,11.67,0,0,1,1.65,3.78c0,.09.06.19.08.28a.65.65,0,0,0,0,.13s0,.05,0,.07l0,.09h0s0,.05,0,.07l.06.24c.22.89.43,1.77.63,2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,312.45c-.88-.78-2.15-2.5-1.34-3.7a1.09,1.09,0,0,1,1.41-.4,3.07,3.07,0,0,1,1.3,1.52c.8,1.52,1.45,3.11,2.35,4.57l.1.16s0,0,0,0l-.09-.14A14,14,0,0,1,181,312.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.7,314.44l0,0a12.8,12.8,0,0,1-.89-1.06,23.87,23.87,0,0,1-1.53-2.45c-.18-.32-1-1.92-1.49-1.11a1.54,1.54,0,0,0,0,1.17,4.49,4.49,0,0,0,.86,1.48,7.73,7.73,0,0,0,2.77,1.91l.14.07,0,0,0,0h0a0,0,0,0,0,.05,0A0,0,0,0,0,184.7,314.44Zm-.31-.13a9.52,9.52,0,0,1-2.33-1.54,4.78,4.78,0,0,1-.89-1.16,4.41,4.41,0,0,1-.26-.59,2.52,2.52,0,0,1-.13-.47c-.06-.35,0-.76.2-.84s.37,0,.59.29a3,3,0,0,1,.22.28c.16.23.31.49.45.74.23.42.47.84.72,1.25s.35.55.54.81a12,12,0,0,0,1.05,1.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,305.36c-.41,1.5-.93,3-1.46,4.42-.3.83-.61,1.65-.91,2.48a6.18,6.18,0,0,0-.63,2.82h0a.53.53,0,0,1,0,.13,0,0,0,0,1,0,0,.11.11,0,0,1-.19-.07.13.13,0,0,1,0-.06v0a3.54,3.54,0,0,1-.21-.84,20.19,20.19,0,0,1-.44-2.32,19.85,19.85,0,0,1,0-4.81,16.12,16.12,0,0,1,1.07-4.16,8.46,8.46,0,0,1,2-3.39c.86-.65,1.31.66,1.43,1.32A10.23,10.23,0,0,1,289.91,305.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,301.93c-.55-.08-1.22,1.65-1.53,2.4a15.58,15.58,0,0,0-1,3.66,20,20,0,0,0,.17,6.82,2.56,2.56,0,0,0,.05.27,0,0,0,0,1,0,0,.13.13,0,0,0,0,.06.11.11,0,0,0,.19.07,5.42,5.42,0,0,1,0-.57c0-.18,0-.35,0-.51a26.72,26.72,0,0,1,1.16-5.45C288.65,306.61,289.76,302,289,301.93Zm-2.26,12.56q0,.38,0,.75c0-.19-.06-.37-.08-.56a22.42,22.42,0,0,1-.19-6,16.34,16.34,0,0,1,.74-3.31,15.73,15.73,0,0,1,.69-1.69c.12-.23.74-1.67,1.08-1.55s.09,1.45.08,1.48a8,8,0,0,1-.11.82c-.08.55-.21,1.11-.33,1.66-.29,1.19-.64,2.37-1,3.55A20.66,20.66,0,0,0,286.76,314.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,310.87a14.83,14.83,0,0,1-5.23,4.15c-1.05.56-2.13,1.07-3.2,1.6a16.06,16.06,0,0,0-2.79,1.56.44.44,0,0,0-.11.09,4.24,4.24,0,0,0-.63.64l-.05,0,0,.08s-.05,0,0,0,0-.07,0-.1h0a0,0,0,0,1,0-.07l0,0,0-.1c.64-2.28,2.61-4.39,4.25-6a12.43,12.43,0,0,1,5.82-3.42c.56-.13,1.86-.52,2.34,0S298.32,310.48,298,310.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.46,310.64c-.41-.55-2,.43-2.41.66a23.16,23.16,0,0,0-3.38,2.43,21.5,21.5,0,0,0-4.58,4.9h0l-.06.06,0,.1,0,0a0,0,0,0,0,0,.07l.08-.07c.21-.19.43-.37.65-.55a.44.44,0,0,1,.11-.09,46.42,46.42,0,0,1,5-3.25,21.71,21.71,0,0,0,3.36-2.42C295.43,312.27,296.81,311.11,296.46,310.64Zm-.6,1c-1.5,1.82-3.8,3-5.79,4.16a25.15,25.15,0,0,0-3.83,2.7,22.76,22.76,0,0,1,4.21-4.39,29.85,29.85,0,0,1,2.77-2.12,13,13,0,0,1,1.62-.95,4.86,4.86,0,0,1,1.07-.38C296.61,310.56,296.11,311.33,295.86,311.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.06,323.6a.14.14,0,0,1-.11,0,.08.08,0,0,0,0,0,0,0,0,0,1,0,.05,0,0,0,0,1,0,0,20.2,20.2,0,0,1-3.64-7.48,10.47,10.47,0,0,1-.18-3.44c.09-.79.29-2.37,1-2.84,1.52-.95,2,4.1,2.1,4.86.14,1.38.16,2.78.26,4.17s.36,3,.58,4.53A.11.11,0,0,1,285.06,323.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.06,323.6c-.06-.14-.11-.27-.16-.41a23.21,23.21,0,0,1-1.46-6.89,21,21,0,0,0-.39-3.54c-.07-.28-.25-1.37-.78-.91a8,8,0,0,0-.35,2.75,14.34,14.34,0,0,0,.6,3.5,23.48,23.48,0,0,0,2.35,5.48l.08.15a0,0,0,0,0,0-.05.05.05,0,0,1,0,0A.14.14,0,0,0,285.06,323.6ZM282.94,319a16.15,16.15,0,0,1-.81-3.43,11.12,11.12,0,0,1-.09-1.41,10,10,0,0,1,.07-1.1c.14-.89.25-1.11.4-1.12s.21.11.39.68a5.6,5.6,0,0,1,.22,1.14c.06.54.1,1.09.14,1.64.07,1.09.13,2.19.28,3.27a17.82,17.82,0,0,0,1.25,4.53A27.6,27.6,0,0,1,282.94,319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8,319.83a6.8,6.8,0,0,1-1.62,2.39c-1.35,1.38-3,2.45-4.41,3.73l-.63.59-.2.3.11-.33h0a27.76,27.76,0,0,1,2.48-5.45,14,14,0,0,1,2.2-2.54c.41-.34,1.35-1.06,1.93-.79S292,319.35,291.8,319.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.89,319.05c-.59-.5-2.73,2.27-3,2.62a19.57,19.57,0,0,0-2.61,4.32c-.08.17-.15.34-.22.52l-.11.33s.18-.28.2-.3l.11-.11.52-.48c.9-1,1.81-2,2.69-3a18.54,18.54,0,0,0,1.73-2.31C290.31,320.49,291.15,319.27,290.89,319.05Zm-.31.83c-1.32,2.48-3.52,4.27-5.32,6.38l-.09.11.09-.2a21.61,21.61,0,0,1,2.11-3.6,20.33,20.33,0,0,1,1.61-2,10.29,10.29,0,0,1,1-1c.15-.13.6-.47.72-.38S290.67,319.71,290.58,319.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.57,299.15c-2.6,4.18-8,5.51-10.87,9.49v0c-.09.12-.17.25-.25.37a.09.09,0,0,1-.15,0s0,0,0-.07l.06-.09a23.34,23.34,0,0,1,3.89-7.42,11.9,11.9,0,0,1,5.52-4.37c.56-.19,1.66-.61,2.18-.08S301.9,298.63,301.57,299.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79,299.08c-.22-.22-.62-.05-.85,0a7.67,7.67,0,0,0-1.63.79,12.43,12.43,0,0,0-2.77,2.45,25.44,25.44,0,0,0-3.6,5.21,13.85,13.85,0,0,0-.59,1.31l-.06.16a.09.09,0,0,0,.15,0c.07-.12.16-.24.24-.36l0,0a14.83,14.83,0,0,1,1.77-2.34,34,34,0,0,1,3.42-3C296.35,302.89,300.56,299.84,299.79,299.08Zm-.46,1a17.68,17.68,0,0,1-2.72,2.46c-.94.78-1.89,1.55-2.82,2.35a17.43,17.43,0,0,0-2.05,2.07,13.16,13.16,0,0,0-1.38,2,19.42,19.42,0,0,1,1.09-2.13l0,0a35.54,35.54,0,0,1,2.44-3.48l0,0a15.4,15.4,0,0,1,2.6-2.69,9.11,9.11,0,0,1,1.73-1.08c.7-.32,1.3-.5,1.43-.27S299.55,299.79,299.33,300.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,303.38c-.77,1.18-1.52,2.37-2.26,3.57l-1,1.69,0,0-.38.61a40.84,40.84,0,0,0-3.17,5.71,18.33,18.33,0,0,0-1,3.29c0,.12,0,.23-.07.35h0l0,.19s0,.07,0,.11c-.18,1-.31,2-.44,2.92-.17,1.34-.25,2.68-.32,4,0,0,0,.08,0,.12a1.09,1.09,0,0,1,0,.18v.09a1,1,0,0,0,0,.17c0,.44-.05.87-.07,1.3l-.41-.06a26.89,26.89,0,0,1,.09-4,.22.22,0,0,1,0-.08l0-.39c0-.16,0-.32.05-.48,0-.38.09-.76.14-1.14a28,28,0,0,1,1.44-6.52c0-.06.05-.11.07-.17l0-.07a.5.5,0,0,1,.05-.13l.08-.19.15-.34,0-.11A44.2,44.2,0,0,1,290,309c.2-.3.39-.6.59-.89l.34-.5.51-.74,0,0c.81-1.16,1.64-2.31,2.44-3.48C294,303.27,294,303.33,294,303.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,326.67c-.41,1.5-.93,3-1.46,4.42-.3.83-.61,1.65-.9,2.48a6.32,6.32,0,0,0-.64,2.82h0a.28.28,0,0,1,0,.13v0a.12.12,0,0,1-.19-.07.13.13,0,0,0,0-.06v0a3.67,3.67,0,0,1-.21-.84,20.16,20.16,0,0,1-.43-2.32,19.35,19.35,0,0,1-.05-4.81,16.3,16.3,0,0,1,1.07-4.17,8.56,8.56,0,0,1,2-3.38c.86-.66,1.3.66,1.42,1.32A10.09,10.09,0,0,1,328.26,326.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.38,323.24c-.56-.09-1.23,1.65-1.54,2.4a15.45,15.45,0,0,0-1,3.66,20.48,20.48,0,0,0,.17,6.81c0,.09,0,.19,0,.28a0,0,0,0,1,0,0,.13.13,0,0,1,0,.06.12.12,0,0,0,.19.07V336c0-.18,0-.35,0-.52a26.09,26.09,0,0,1,1.15-5.44C327,327.92,328.11,323.35,327.38,323.24Zm-2.27,12.56c0,.25,0,.5,0,.75,0-.19-.07-.37-.09-.56a22.42,22.42,0,0,1-.18-6,15.78,15.78,0,0,1,.74-3.32,12.89,12.89,0,0,1,.69-1.68c.11-.23.74-1.67,1.07-1.55s.09,1.45.09,1.48c0,.27-.07.54-.11.82-.09.55-.21,1.11-.34,1.66-.29,1.19-.64,2.37-1,3.55A21.18,21.18,0,0,0,325.11,335.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.39,332.17a14.71,14.71,0,0,1-5.22,4.16c-1.06.56-2.14,1.07-3.21,1.6a15.43,15.43,0,0,0-2.79,1.56l-.11.08a4.67,4.67,0,0,0-.62.64.09.09,0,0,1-.06,0,.3.3,0,0,1,0,.08s0,0,0,0l0-.1h0a.06.06,0,0,1,0-.08l0,0s0-.07,0-.1c.64-2.28,2.61-4.39,4.25-6a12.63,12.63,0,0,1,5.82-3.43c.57-.12,1.86-.51,2.34,0S336.67,331.78,336.39,332.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.81,332c-.41-.56-2,.43-2.41.66A23.71,23.71,0,0,0,329,335a21.51,21.51,0,0,0-4.58,4.9h0a.34.34,0,0,1-.06.06.3.3,0,0,0,0,.1l0,0a.06.06,0,0,0,0,.08l.08-.07.65-.56.11-.08a46.89,46.89,0,0,1,5-3.25,21.71,21.71,0,0,0,3.36-2.42C333.79,333.58,335.16,332.42,334.81,332Zm-.6,1c-1.5,1.82-3.8,3-5.78,4.16a24.09,24.09,0,0,0-3.84,2.7,22.87,22.87,0,0,1,4.22-4.4,30,30,0,0,1,2.76-2.11,12.6,12.6,0,0,1,1.63-.95,4.6,4.6,0,0,1,1.06-.38C335,331.87,334.47,332.64,334.21,333Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.41,344.91a.14.14,0,0,1-.11,0s0,0,0,0a0,0,0,0,1,0,.05s0,0-.05,0a20.36,20.36,0,0,1-3.64-7.48,10.53,10.53,0,0,1-.18-3.45c.1-.78.29-2.36,1-2.84,1.52-.94,2,4.1,2.1,4.86.14,1.39.16,2.79.27,4.17s.35,3,.58,4.54A.11.11,0,0,1,323.41,344.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.41,344.9c-.05-.13-.11-.26-.15-.4a22.91,22.91,0,0,1-1.47-6.9,20,20,0,0,0-.39-3.53c-.07-.29-.25-1.37-.77-.91a7.91,7.91,0,0,0-.36,2.75,14.34,14.34,0,0,0,.6,3.5,23.91,23.91,0,0,0,2.35,5.48l.09.15a0,0,0,0,0,0-.05.08.08,0,0,0,0,0A.12.12,0,0,0,323.41,344.9Zm-2.12-4.58a17.47,17.47,0,0,1-.81-3.43,11.11,11.11,0,0,1-.08-1.41,6.7,6.7,0,0,1,.07-1.1c.13-.89.24-1.11.39-1.12s.21.11.39.68a5.47,5.47,0,0,1,.22,1.14c.06.54.11,1.09.14,1.64.07,1.09.13,2.19.29,3.27a17.4,17.4,0,0,0,1.24,4.53A28.62,28.62,0,0,1,321.29,340.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,341.14a6.68,6.68,0,0,1-1.62,2.38c-1.34,1.39-3,2.46-4.4,3.74-.22.19-.43.39-.64.59l-.2.3s0-.13.11-.33h0a27.6,27.6,0,0,1,2.49-5.46,13.55,13.55,0,0,1,2.2-2.53c.4-.34,1.34-1.06,1.93-.79S330.32,340.66,330.15,341.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.25,340.36c-.6-.5-2.73,2.27-3,2.62a19.16,19.16,0,0,0-2.6,4.32c-.08.17-.16.34-.23.52s-.11.32-.11.33.18-.28.21-.3l.1-.11.52-.48c.9-1,1.81-2,2.69-3a17.6,17.6,0,0,0,1.73-2.31C328.66,341.8,329.51,340.58,329.25,340.36Zm-.32.82c-1.32,2.49-3.52,4.28-5.32,6.39l-.09.1a1.63,1.63,0,0,0,.09-.19,22.32,22.32,0,0,1,2.11-3.6,20.43,20.43,0,0,1,1.62-2,10.26,10.26,0,0,1,1-1c.16-.12.6-.46.72-.37S329,341,328.93,341.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,320.46c-2.61,4.18-8,5.51-10.87,9.49l0,0c-.09.12-.17.25-.25.37a.09.09,0,0,1-.15,0s0,0,0-.07l.06-.09a23.54,23.54,0,0,1,3.89-7.42,11.9,11.9,0,0,1,5.52-4.37c.56-.19,1.67-.61,2.19-.08S340.25,319.94,339.93,320.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.15,320.39c-.22-.22-.63-.05-.86,0a7.67,7.67,0,0,0-1.63.79,12.38,12.38,0,0,0-2.76,2.45,25.49,25.49,0,0,0-3.61,5.21c-.22.43-.41.86-.59,1.31l-.06.16a.09.09,0,0,0,.15,0L329,330l0,0a14.83,14.83,0,0,1,1.77-2.34,36.31,36.31,0,0,1,3.42-3C334.7,324.2,338.91,321.14,338.15,320.39Zm-.47,1a17.23,17.23,0,0,1-2.72,2.46c-.94.78-1.89,1.55-2.82,2.35a17.35,17.35,0,0,0-2,2.07,13.22,13.22,0,0,0-1.39,2,20.32,20.32,0,0,1,1.09-2.13l0,0a34.37,34.37,0,0,1,2.44-3.48l0,0a15.71,15.71,0,0,1,2.59-2.69,9.11,9.11,0,0,1,1.73-1.08c.7-.32,1.3-.5,1.43-.27S337.91,321.1,337.68,321.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,324.69c-.77,1.18-1.52,2.37-2.26,3.57-.36.56-.7,1.13-1.05,1.69l0,0-.37.61a39.91,39.91,0,0,0-3.18,5.71,19.18,19.18,0,0,0-1,3.29c0,.12,0,.23-.07.35h0l0,.19s0,.07,0,.11c-.18,1-.31,2-.43,2.92-.18,1.34-.26,2.68-.33,4v.12c0,.06,0,.12,0,.18v.09a.91.91,0,0,1,0,.17c0,.43,0,.86-.07,1.3l-.41-.06a26.89,26.89,0,0,1,.09-4s0-.05,0-.08,0-.26,0-.39a3.91,3.91,0,0,1,.05-.48c0-.38.08-.76.13-1.14a28.35,28.35,0,0,1,1.44-6.52c0-.06.05-.12.07-.17l0-.08a.61.61,0,0,1,0-.12l.08-.19c.05-.12.1-.23.16-.35l0-.1a44.2,44.2,0,0,1,3.05-5.09l.6-.89.33-.5.51-.74,0,0c.81-1.17,1.64-2.31,2.44-3.48C332.3,324.58,332.39,324.64,332.36,324.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,360.44H164.43s-.65-17,5.53-23.18,12.14-7.68,14.14-9a114.34,114.34,0,0,0,13.23-11.95c4.51-4.81,11-12,14.36-12.68s18.71-3.35,21.88-2.28,20.33,13.51,22.17,14.05,34.95,13.9,37.95,14.42,20.18,4.56,27.73,8.25C331.77,343.14,339.29,360.44,339.29,360.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.79,327.79c-7.68.35-19.05,7.15-21.3,8.19-3.31,1.55-23.22-4-31.07-4.67s-10.35-10.42-9.87-12-8.58-4.38-7.45-8.14c.66-2.2,21.09-6.58,21.09-6.58,6.26,4,15.25,10.41,16.55,10.79S277.37,323.93,287.79,327.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,328.27c.15-2.6,8.76-7.07,11-6.66s6.64,4.13,7.26,5.58,3.51,8.46.75,8.51-8-4-10.89-4.11S204.82,330.4,205,328.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,338.28c-.54-1.62,7.45-4.76,9.53-4.47s4.08,3.71,2.25,4.61-4.53-.37-5.94,0S270.15,339.51,269.74,338.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.25,364.17H127.1c-4,0,4.57-9.9,8.07-11.34s12.66-.62,14.91,1,11.79,6.66,13,7.5A2.77,2.77,0,0,1,164.25,364.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,365h75.6s-3.54-4-7.45-4.82-12.76-3.4-14.36-4.82-15.08-6.67-20.22-6.53-13.65,4.83-14.9,6-5.58,5.39-7,5.74S301.84,361.74,298.34,365Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,358.35a23.17,23.17,0,0,1-4.36.31c-.61-.06-6.54-2.38-8.72-2.62s-14-.64-14.86-1.68c-.65-.78,3.86-3.24,6.83-4.52,5.88,1.56,13,4.51,14.16,5.52.82.73,3.56,1.75,6.57,2.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,358.07c0-.52,3.92-.91,4.82-.8s4.8,1.46,4,1.72a12.82,12.82,0,0,1-3.81.39C343.06,359.3,339.29,358.66,339.29,358.07Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.17,317.52c17.27,12.21,70.17,38.59,93.69,35,15.85-2.44,55.42-39.43,62.77-51.91,3-5.11-33.94-36.38-39.23-32.9-5.76,3.79-30.29,38.83-34.84,40.15s-48.43-6.08-72.87-7.3C123.05,299.79,120.26,311.93,128.17,317.52Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,311.13c8.27-7.08,30.12-37.74,33.07-44.74s10-27.75,4.86-30.56-7.67,3.11-7.67,3.11,1.88-10.08-3.84-11.59c-4.56-1.2-8.58,6.93-8.58,6.93s1.48-11.16-4.38-11.93c-5.34-.7-7.46,9.16-7.46,9.16s.29-9.46-5-9.14c-6.35.38-6.86,16.75-10.7,24.23-.87,1.7-32.84,34.36-32.84,34.36Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.52,231.16c-1.63,12.23-2.66,17.24-9.33,27-.13.19.13.43.28.24,7.4-9,9.06-14.87,9.64-27.3C282.14,230.55,281.6,230.59,281.52,231.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,234.31c-1.52,12.47-4.12,17.9-10.35,28.69-.09.16.16.32.26.17,7-10.07,10.62-16.25,10.5-28.91C294,233.69,293.69,233.74,293.62,234.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,239.47c-2.34,12-4.7,18.29-12.09,28a.22.22,0,0,0,.34.29c8.49-9.16,11.5-17,12.11-28.17C306.24,238.82,306,238.72,305.84,239.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.37,281s6-13,8.55-19.26,7.27-25.08,12.88-26.65c6.31-1.77,7.53,15.81,3.08,27.08,0,0,15.59,12.36,11.83,23.39-.82,2.38-9.47,12.07-12.33,12.48Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.84,263.44c6.23,4.59,12.34,12.78,11.77,20.49a.18.18,0,0,0,.35.05c1.73-8.18-5.24-17.72-11.06-21.49C257.78,261.77,256.22,262.25,257.84,263.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,223.34,270.78,283.2,264,302.71l-10.39,30c-12,10.11-24.43,18.67-31.78,19.8-23.52,3.63-76.41-22.77-93.69-35-7.92-5.59-5.12-17.72,9.52-17,24.44,1.22,68.31,8.62,72.87,7.3,2.89-.85,13.89-15.34,23-26.75l-.16-.12s6-13,8.54-19.27,7.26-25.07,12.88-26.64c4.81-1.35,6.66,8.52,5.3,18.29,3.45-3.63,5.87-6.28,6.11-6.73,3.84-7.49,4.35-23.86,10.69-24.24,5.27-.32,5,9.15,5,9.15s2.13-9.87,7.47-9.17A3.9,3.9,0,0,1,291.53,223.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.09,355.93l12.54-49.33s-49-7.82-73.08-7.54c-20.22.24-24.63,14.65-2.13,27.47C155.71,338.67,197.09,355.93,197.09,355.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,309a78.09,78.09,0,0,0-2.88,8.81c-.93,3.05-1.74,6.13-2.56,9.19s-3.64,15.43-4.34,18.51c0,.14.22.17.26,0,.94-3.05,4.64-15.15,5.43-18.17s1.61-6,2.31-9a79,79,0,0,0,1.93-9.29C196.87,309,196.74,309,196.71,309Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.78,341.41l-3.69,14.52s-41.37-17.26-62.67-29.4c-19.77-11.27-18.77-23.76-4.52-26.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,465.46l-139.42-.24c.35-2.87,29.44-132.19,63.16-162,11.58-10.23,33.74-2.63,36.52-.36C172.38,324.9,187.18,463.78,185.15,465.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.07,457.93H47.33c.89-3.83,2.14-9,3.7-15.15h132.6C184.31,448.9,184.8,454.07,185.07,457.93Zm-5.15-43.32H58.67c-1.53,5.3-2.94,10.38-4.23,15.14H182.05C181.42,425,180.71,419.9,179.92,414.61Zm-4.76-28.16H67.33c-1.68,5.09-3.28,10.16-4.8,15.14H177.86C177,396.61,176.13,391.53,175.16,386.45Zm-6-28.18H77.43c-1.94,5-3.83,10-5.64,15.15H172.56C171.47,368.29,170.32,363.21,169.11,358.27Zm-8.27-28.16H90c-2.45,4.73-4.85,9.82-7.18,15.14h82.86C164.14,339.89,162.53,334.81,160.84,330.11Zm-15.43-27.24a9.72,9.72,0,0,0-1.63-.93H110.55a15.81,15.81,0,0,0-1.66,1.3A68.36,68.36,0,0,0,97.5,317.08h57.92C152.3,310.71,149,305.78,145.41,302.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06,299.46l-7.24,20.08-27.64-23.11-5,9.68s27.11,35.7,27.11,34l6.66-16.9,12.64,10.26-3.41-28.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.72,319.41c-.73-4.63-1.32-9.33-2.27-13.92,0-.17-.31-.22-.34,0-.58,4.59,2.29,22.31,2.64,26.59l-.05-.05c-.53-.44-11.67-9-11.76-8.82-1.52,2.73-6.42,15-6.73,16.14-4.29-5.67-22.34-27.93-27.29-33.22-.14-.15-.39,0-.28.19,3.88,6,27.25,35.46,27.54,35.35.21.13,6.31-15,6.95-17.85,1.92,1.9,13.27,11.64,13.24,10.94A143.61,143.61,0,0,0,153.72,319.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.35,323.7c-8,2.14-22.16-9.75-27.91-19.55-.39-.67.44-7.9,1-16.74.34-5.36.6-11.34.44-16.81,0-1.12,34.57,7.32,34.57,7.32s-3,11.57-2.7,21.11a12.89,12.89,0,0,0,.3,2.24,2.86,2.86,0,0,1,.06.37C149,305.89,150.07,321.62,142.35,323.7Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,270.68c1.87,9.2,8.28,31.39,26.61,31.26a20.9,20.9,0,0,0,3.5-.29,1.35,1.35,0,0,0,0-.38,13,13,0,0,1-.31-2.23c-.34-9.55,2.71-21.12,2.71-21.12S125.52,271.82,118,270.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7,234.89c-1.69,12.61,10.38,46.27,20.2,52.6,14.23,9.17,34.69,6.9,41.76-9.56,6.86-15.95-9.63-59.54-20.34-65C130.56,204.9,107.19,216.25,104.7,234.89Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,270.64c6.84-2.08,9.49-10.67,7-24.1s-1.61-18.87,4.27-22.34,14.4.67,17.73-.3,1.06-6.29,3.82-7c1.36-.36,6.23,2.69,11.79,11.21,0,0-6.35-25.2-33.2-16.71-25,7.9-22,28.91-20.46,35C106.41,256.36,113,270.64,113,270.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,224c-.56-.25,9.38-17.41,13.72-21s26.58-5.39,27.6-4S96.41,224.62,95.1,224Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.41,199c1,1.37-40,25.62-41.31,25-.28-.12,2.12-4.57,5.12-9.4,0,0,0,0,0-.06,3.74-3.92,8.32-8.26,9.34-9.22s6.12-3.46,10.81-5.71C127.77,198.49,135.81,198.19,136.41,199Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,252.63c-.73.25-11.16-12.88-12.92-14.66s-5.8-2.41-6.13-3.88,16.9-21.54,24.74-27.35,38.09-12.82,38.6-11.81-.33,3.66,0,5.94,5.4,18.74,4.53,18.88c-8.88,1.35-23.36,6.73-29.24,11.39C120,235,107.65,251.8,105.18,252.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,238.8l-1.43-1.67c.7-.79,17.17-19.34,23.35-24,4.07-3.08,29.05-12.33,34.33-13.33l.5,2.19c-5,1-29.82,10.14-33.65,13C110,219.58,93.14,238.61,93,238.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1,260.45s4.19,7.74.13,13.55-2.71,13.59.09,16.09c0,0-5,14.08,8,16.61,0,0-.89,14.33,14.9,15.78,0,0,4.75,4.83,12.68,1,0,0,12.92,3.33,18.62-6.85,0,0,13.68,1.28,14.23-15.11,0,0,8.61-6.91,2.4-16,0,0,6.12-7-1.95-12.8,0,0,3.27-11.21-10.48-14.06a5.08,5.08,0,0,0-4.71-5.34s-6.91-3-8.35-7c0,0,2.55,8.42-1.93,10.94-4,2.26-9.08,1.6-9.08,1.6s-5.49,7.06-18.22,6.81c-11-.22-15.94-11.88-15.94-11.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43,262s-9.9-9.73-14.45-6,4.33,18.85,10.69,20a6.17,6.17,0,0,0,7.52-4.76Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.63,260.22c-.1,0-.09.15,0,.17,4.49.91,7.41,4.38,9.69,8.11-1.53-1.32-3.38-1.85-5.17,0-.1.1,0,.25.15.2a3.82,3.82,0,0,1,4.35.54,18.64,18.64,0,0,1,2.57,3c.27.34.91,0,.68-.39a.41.41,0,0,0-.05-.09C120,266.38,114.45,259.7,108.63,260.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.11,245.78c0-.09.21.05.24.14.73,2.3,2,4.81,4.27,4.84.07,0,.1.12,0,.13C158,251.42,156.43,248.07,156.11,245.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.3,242.7c3.56-1.57,6.42,5.66,3.13,7.11S154.32,244,157.3,242.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,248.86c1.07-.2,2-.57,3.07-.87a5.19,5.19,0,0,0,3-1.49,1.63,1.63,0,0,0-.14-2c-1.09-1.1-2.64-1-4.07-.68a6,6,0,0,0-3.61,2.37A1.76,1.76,0,0,0,137,248.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,236.79a28.26,28.26,0,0,1-3.19-.1c-1.23-.05-2.21,0-3.24-.72a1.64,1.64,0,0,1-.35-2c.8-1.34,2.31-1.65,3.79-1.65a6,6,0,0,1,4.07,1.42A1.76,1.76,0,0,1,158.47,236.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,272.32a3.66,3.66,0,0,0,2.38.66,6.35,6.35,0,0,0,2.24-1.43.09.09,0,0,1,.14.09,3.23,3.23,0,0,1-2.45,2.24,2.57,2.57,0,0,1-2.49-1.38C147.28,272.38,147.44,272.27,147.55,272.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,252.36a6.59,6.59,0,0,1,1.73-1,7,7,0,0,1,2-.42,5.71,5.71,0,0,1,2.17.35,5.24,5.24,0,0,1,1.95,1.32l1,1.06-1.35.22a13.31,13.31,0,0,0-2.79.77,5.57,5.57,0,0,0-2.39,1.76,4.3,4.3,0,0,1,1.83-2.76,7.62,7.62,0,0,1,3.06-1.28l-.35,1.28a5.22,5.22,0,0,0-3.09-1.44A14.66,14.66,0,0,0,137.14,252.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,256.9a11.54,11.54,0,0,0,2.48-1.94c.16-.2.76-1,.66-1.2a6.42,6.42,0,0,0-1-1.38,4.54,4.54,0,0,1,1.26,1.25,2.11,2.11,0,0,1-.6,1.69A5.81,5.81,0,0,1,142.59,256.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.27,269c2.46-2.19,6.29-3.18,8.74-3.75.25-.13.3-.73.25-1h0l-1.91-4.75c.75.09,4.5.36,4.12-.53-3.19-7.3-6.73-15.43-11.44-22a.22.22,0,0,0-.39.21c2.79,7.14,6.8,13.75,9.71,20.88a14.29,14.29,0,0,0-4,.23c-.22.16,2.27,4.91,2.47,5.72,0,0-5.08.3-7.95,4.05C147.13,269,147.09,270,148.27,269Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.27,269c2.46-2.19,6.29-3.18,8.74-3.75.25-.13.3-.73.25-1h0l-1.72-4.28c-.54-.77-1.79-.38-1.51.13s1.59,3.07,1.79,3.88c0,0-5.08.3-7.95,4.05C147.13,269,147.09,270,148.27,269Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.77 256.65 157.22 257.27 156.18 239.68 233.26 231.16 234.77 256.65",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.5 261.23 200.83 259.64 199.21 232.19 276.15 221.46 278.5 261.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.87 268.31 256.64 262.74 254.26 222.53 312.42 210.03 315.87 268.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.13,238.93c.87,14.7-.21,26.72-2.41,26.85s-4.7-11.68-5.57-26.38.22-26.71,2.42-26.84S317.26,224.24,318.13,238.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,333.61c25.08,26.49,91.6,70,106.33,64.05,27.17-11.05,37.67-88.8,41.17-103.9,1.49-6.44-54-10.87-55.75-4-1.51,6-4.09,46.84-9.17,48.31-2.08.61-32.49-11.82-67-19.78C98.67,312.17,102.15,325.77,109.57,333.61Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.65,302.35s1.38-6.36.08-22.17c-1-12.36,5.2-42.11,36.11-58.19,11.85-6.16,21.34-.54,10.17,8-7.86,6-13.83,9.56-15.85,12.25,0,0,15.19.26,20.16,7.52A161.32,161.32,0,0,1,262,269.71a34.73,34.73,0,0,1-3.53,2.51,18.5,18.5,0,0,1-1,19.69l-2.64,13.31Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,269.31C205.93,264,214,252.84,223.81,246c10.88-7.57,33.87-19.23,39.37-11.14,4,5.93-4.35,11.15-4.35,11.15s10.52-2.82,13,3.34c2.25,5.6-4.47,9.25-4.47,9.25s6.67-.61,7.8,5.21c1.37,7-12.85,7.14-17.59,15.42C256.5,281.11,202.2,269.31,202.2,269.31Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,258.84c4.33-4.43,16.74-12,28.7-12.94.27,0,.43.18.19.25A129.58,129.58,0,0,0,230,259C229.9,259,229.85,258.89,229.89,258.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.86,269.6c4.12-3.44,17.26-10.64,29.41-11.2.27,0,.42.19.18.25a139.2,139.2,0,0,0-29.53,11.06C237.86,269.74,237.8,269.64,237.86,269.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.51,382.67l21.31-46.22S144,319.83,120.33,315.73c-19.92-3.45-26.88,9.92-7.09,26.62C132,358.16,169.51,382.67,169.51,382.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,336.47a79.51,79.51,0,0,0-4.44,8.14c-1.47,2.83-2.82,5.71-4.19,8.58s-6.39,14.5-7.64,17.4c0,.13.19.21.25.09,1.48-2.83,7.32-14.06,8.65-16.88s2.68-5.63,3.92-8.48a78.15,78.15,0,0,0,3.59-8.78C177.83,336.48,177.72,336.41,177.68,336.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.18,348c12.76,8.08,25,16.9,37.22,25.72,4.07,2.94,8.11,5.93,12.26,8.72l-.42.13c.8-1.41,1.6-2.81,2.44-4.2-.64,1.6-1.33,3.18-2,4.76l-.3-.15c-9-4.71-17.12-10.62-25.35-16.44s-16.16-12-23.83-18.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,351.07a54.1,54.1,0,0,1,8.25,4,18.45,18.45,0,0,1-8.25-4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.75,465.26c130.86-.62,277.64-.62,408.5,0-130.86.61-277.64.61-408.5,0Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPage);
export default __webpack_public_path__ + "static/media/error_page.0045cb5ca274721820d588aa6ed97e79.svg";
export { ForwardRef as ReactComponent };